import { render, staticRenderFns } from "./ReportTemplateDesigner.vue?vue&type=template&id=6edb1f4c&scoped=true"
import script from "./ReportTemplateDesigner.vue?vue&type=script&lang=js"
export * from "./ReportTemplateDesigner.vue?vue&type=script&lang=js"
import style0 from "./ReportTemplateDesigner.vue?vue&type=style&index=0&id=6edb1f4c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb1f4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6edb1f4c')) {
      api.createRecord('6edb1f4c', component.options)
    } else {
      api.reload('6edb1f4c', component.options)
    }
    module.hot.accept("./ReportTemplateDesigner.vue?vue&type=template&id=6edb1f4c&scoped=true", function () {
      api.rerender('6edb1f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/print-template/ReportTemplateDesigner.vue"
export default component.exports